export default __webpack_public_path__ + "static/media/image-main-1-w@2x.6b24bccc.webp";